import React from 'react';

import { RefundProps } from '../types';
import { useI18n } from '~Hooks';

export const RefundRetain24 = (props: RefundProps) => {
  const { i18n } = useI18n();
  const { onFail } = props;

  /*
   * We don't support refunds for R24 that's why we just return here and latest info is that it can be seen as permanent.
   * However if we somewhere in the future want to do it later we can use the <Retain24Payment /> with props.type="REFUND".
   * onFail here triggers a notification that we don't support refunds for R24.
   */
  onFail(i18n('History.RefundFailed.R24'));
  return <></>;
};
